import { useState, useEffect, useRef } from 'react';
import './chat.css';
import emea from '../../img/emea24.png';
import powered from '../../img/powered.png';

import { FaRegPaperPlane } from 'react-icons/fa';

import "@fontsource/poppins"; // Defaults to weight 400
import "@fontsource/poppins/400.css"; // Specify weight
import "@fontsource/poppins/400-italic.css"; // Specify weight and style

import Message from './message';

function Chat() {

    const [content, setContent] = useState([]); // full of history
    const [singleMessage, setSingleMessage] = useState(''); // single message state
    const [blockButton, setBlockButton] = useState(false); // block button state
    const [actualIndex, setActualIndex] = useState(0); // index of actual message

    const [showExample, setShowExample] = useState(false);

    const [exampleContent, setExampleContent] = useState([]);

    let fullContext = useRef('');   // context for chat state

    const messagesEndRef = useRef(null)

    // create example content
    const createExampleContent = () => {

        setExampleContent([]);

        setExampleContent(oldArray => [...oldArray, 
            {
                id: 0,
                message: "Hi",
                who: 'User'
            }]);

        setExampleContent(oldArray => [...oldArray, 
            {
                id: 0,
                message: 'Hello! How can I assist you with information about the "Directions for partners EMEA 2024" conference in Vienna?',     
                who: 'AI'
            }]);

        setExampleContent(oldArray => [...oldArray, 
            {
                id: 1,
                message: "Where can I met with Data Courage Team?",
                who: 'User'
            }]);
    
        setExampleContent(oldArray => [...oldArray, 
            {
                id: 1,
                message: "You can meet the Data Courage team at their booth, which is located at Booth number S33 on Expo Level 0.",     
                who: 'AI'
            }]);
    }


    // scroll action
    const scrollToBottom = () => {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
    }

    useEffect(() => {
        if(exampleContent.length === 0){
            createExampleContent();
        };

        scrollToBottom();
      }, [content, fullContext, exampleContent]);

    // clear chat context
    const handleClearContext = () => {
        fullContext.current = '';
    }

    const handleContext = async ( input, type ) => {
        let context = '';
        let contextLength = fullContext.current.length;
        let startIndex = 0;

        if(contextLength > 50000){
            startIndex = contextLength - 20000;
            fullContext.current = fullContext.current.substring(startIndex, contextLength); 
            let promptIndex = fullContext.current.indexOf('user:');
            fullContext.current = fullContext.current.substring(promptIndex, fullContext.current.length); 
        };

        if(type === 'question'){
            context = "user:" + input; };
        if(type === 'answer'){
            context = '#AI: ' + input; 
        };

        // set actual context
        fullContext.current = fullContext.current + context;
    }

    const submitMessage = async () => {
        try{
            if(singleMessage !== ''){
                // block button for send next message
                setBlockButton(true);
                // set full context
                handleContext(singleMessage, 'question');
                // clear input -> visibility
                setSingleMessage('');
                // set message from userside
                handleSetContent( singleMessage, 'User' );
                // increment key
                setActualIndex(prev => prev + 1);
                // header
                const requestOptions = {
                    method: 'POST',
                    //mode: "no-cors",
                    headers: { 
                        'Content-Type': 'text/html; charset=utf-8',
                        'Access-Control-Allow-Origin': '*'
                    },
                    body: JSON.stringify(fullContext.current)
                };
                
                //fetch('http://127.0.0.1:5000', requestOptions)
                fetch('https://dcchatapi.azurewebsites.net/', requestOptions)
                .then(async response => {
                        // check for error response
                        if (!response.ok) {
                            // get error message from body or default to response status
                            const error = (response && response.message) || response.status;
                            return Promise.reject(error);
                        }
                        
                        const responseText = await response.text();
                        return responseText;

                    }).then( (data) => {
                        setTimeout(() => handleSetContent( data, 'AI' ), 500);
                        setActualIndex(prev => prev + 1);
                        handleContext(data, 'answer');
                        setBlockButton(false);
                    }).catch(error => {
                        setBlockButton(false);
                        console.error('There was an error!', error);
                        setTimeout(() => handleSetContent( "Please click start again...", 'AI' ), 500);
                    });
            }
        }catch (e){
            console.error(e.message);
        }
    }

    // event handler for click on enter button
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && !blockButton) {
            submitMessage();
        }
      };

    // handler for setting content
    const handleSetContent = ( message, who ) => {
        setContent(oldArray => [...oldArray, 
            {
                id: actualIndex,
                message,
                who
            }]);
    }

    // DOM
    return (
        <>
            <div className={showExample ? 'container__example' : 'container__example--disable'}>
                <div className='logo__container--right'>
                    <img src={emea} alt="emea" className='logo__img'/>
                </div>

                <div className='container__padding'>
                    {/* conversation */}
                    <div className='container_content'>
                        {exampleContent.map( (elem) => <Message 
                            key={elem.id + elem.who} 
                            message={elem.message} 
                            who={elem.who} 
                            smooth={false} 
                        />)}
                        <div ref={messagesEndRef} />
                    </div>
                    {/* conversation */}
                    <div className='container__input'>
                        <div className='container--mobile'>
                            <input 
                                className='message__input' 
                                placeholder='Ask me something about Directions EMEA 2024'
                                onChange={ (e) => {
                                    setSingleMessage(e.target.value);
                                }}
                                onKeyDown={handleKeyDown}
                                value={ singleMessage }
                                disabled={true}
                            />

                            <button
                                onClick={() => submitMessage()}
                                className='message__submitButton'
                                disabled={true}
                            >
                                <FaRegPaperPlane />
                            </button>
                        </div>

                        <div className='container--mobile'>
                                
                            <img src={powered} alt="emea" className='logo__img'/>
                            {/* <div className='container__buttons--mobile'> */}
                                <button
                                    onClick={() => {
                                        setShowExample(false);
                                    }}
                                    className='message__clearButton'
                                >
                                    Hide example
                                </button>

                                <button
                                    onClick={() => {
                                        handleClearContext();
                                        setActualIndex(0);
                                        setContent([]);
                                        setSingleMessage('');
                                    }}
                                    className='message__clearButton'
                                    disabled={true}
                                >
                                    Start Again
                                </button>
                            {/*  </div> */}
                        </div>    
                    </div>
                </div>
                <div className='footer'>
                    EMEA Expo Booth S33
                </div> 
            </div>
        {/* Example | Normal              <div className={showExample ? 'container__example' : 'container__example--disable'}>*/}
            <div className={showExample ? 'container__example--disable' : 'container'}>
                <div className='logo__container--right'>
                    <img src={emea} alt="emea" className='logo__img'/>
                </div>

                <div className='container__padding'>
                    {/* conversation */}
                    <div className='container_content'>
                        {content.map( (elem) => <Message 
                            key={elem.id + elem.who} 
                            message={elem.message} 
                            who={elem.who} 
                            smooth={true} 
                        />)}
                        <div ref={messagesEndRef} />
                    </div>
                    {/* conversation */}
                    <div className='container__input'>
                        <div className='container--mobile'>
                            <input 
                                className='message__input' 
                                placeholder='Ask me something about Directions EMEA 2024'
                                onChange={ (e) => {
                                    setSingleMessage(e.target.value);
                                }}
                                onKeyDown={handleKeyDown}
                                value={ singleMessage }
                            />

                            <button
                                onClick={() => submitMessage()}
                                className='message__submitButton'
                                disabled={blockButton}
                            >
                                <FaRegPaperPlane />
                            </button>
                        </div> 

                        <div className='container--mobile'>
                                
                            <img src={powered} alt="emea" className='logo__img'/>
                            {/* <div className='container__buttons--mobile'> */}
                                <button
                                    onClick={() => {
                                        setShowExample(true);
                                    }}
                                    className='message__clearButton'
                                >
                                    Show example
                                </button>

                                <button
                                    onClick={() => {
                                        handleClearContext();
                                        setActualIndex(0);
                                        setContent([]);
                                        setSingleMessage('');
                                    }}
                                    className='message__clearButton'
                                    disabled={blockButton}
                                >
                                    Start Again
                                </button>
                            {/*  </div> */}
                        </div>    
                    </div>
                </div>
                <div className='footer'>
                    EMEA Expo Booth S33
                </div> 
            </div>
        </>
    );
}

export default Chat;
